export default function(_) {
  return _ == null || _ === '' ? null : _ + '';
}



// WEBPACK FOOTER //
// ./~/vega-util/src/toString.js